import { useEffect, useMemo } from "react";
import { useRouter } from "next/router";

const BreadcrumbsJsonLd = () => {
  const router = useRouter();

  const breadcrumbs = useMemo(() => {
    const pathSegments = router.asPath.split("/").filter(Boolean);

    const breadcrumbList = [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://www.venturawebdesign.com/",
      },
    ];

    pathSegments.forEach((segment, index) => {
      if (index === 0) {
        // Assuming the first segment is always 'learn' for blog listing
        breadcrumbList.push({
          "@type": "ListItem",
          position: 2,
          name: "Learn",
          item: `https://www.venturawebdesign.com/${segment}`,
        });
      } else {
        // The blog post title should be properly capitalized and spaces inserted
        const title = segment.replace(/-/g, " ").replace(/\b(\w)/g, (s) => s.toUpperCase());
        breadcrumbList.push({
          "@type": "ListItem",
          position: 3,
          name: title,
          item: `https://www.venturawebdesign.com/learn/${segment}`,
        });
      }
    });

    return {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: breadcrumbList,
    };
  }, [router.asPath]);

  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.innerHTML = JSON.stringify(breadcrumbs);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [breadcrumbs]);

  return null;
};

export default BreadcrumbsJsonLd;
